import HandleRequest from "./HandleRequest";

export type PhoneCall = {
  id: number;
  call_sid: string;
  direction: "inbound" | "outbound";
  from_number: string;
  to_number: string;
  user_id: number | null;
  customer_id: number | null;
  customer_name: string | null;
  rep_username: string | null;
  status: string;
  duration: number;
  is_voicemail: number;
  recording_sid: string | null;
  recording_duration: number | null;
  started_at: string | null;
  ended_at: string | null;
  created_at: string;
};

export type PhoneCallsQuery = {
  page?: number;
  perPage?: number;
  sort?: string;
  order?: "asc" | "desc";
  search?: string;
  direction?: "inbound" | "outbound" | "";
  hasRecording?: boolean;
};

export type SoftphoneToken = {
  token: string;
  identity: string;
  expires_in: number;
  /**
   * The rep's assigned Twilio number, or null when they have none. Null does
   * not mean calling is off -- an unassigned rep still receives calls; it means
   * they cannot place one, so the customer list grays its numbers out.
   */
  caller_id: string | null;
};

const { getRequest, postRequest, getBlobRequest } = HandleRequest();

function buildQuery(query: PhoneCallsQuery): string {
  const params = new URLSearchParams();

  if (query.page) params.set("page", String(query.page));
  if (query.perPage) params.set("per_page", String(query.perPage));
  if (query.sort) params.set("sort", query.sort);
  if (query.order) params.set("order", query.order);
  if (query.direction) params.set("direction", query.direction);
  if (typeof query.hasRecording === "boolean") {
    params.set("has_recording", String(query.hasRecording));
  }

  const search = query.search?.trim();
  if (search) params.set("search", search);

  const queryString = params.toString();
  return queryString ? `?${queryString}` : "";
}

export default function PhoneCallsService() {
  return {
    list: async (query: PhoneCallsQuery = {}) =>
      getRequest(`/api/v1/phone-calls${buildQuery(query)}`),
    get: async (id: number) => getRequest(`/api/v1/phone-calls/${id}`),
    recording: async (id: number) =>
      getBlobRequest(`/api/v1/phone-calls/${id}/recording`),
    token: async () => postRequest("/api/v1/phone-calls/token", {}),
  };
}
